import type { OrderInvoicePayload } from '../../model/invoice/interfaces'

import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useOrderInvoiceStore } from '../../model/invoice/store'
import { getBlobErrorMessage } from '../../lib/blob-response'

/** `POST /admin-api/orders/{order}/invoices/preview` — the PDF with the given fields; nothing is stored. */
export const useOrderInvoicePreview = async (
  orderId: string | number,
  payload: OrderInvoicePayload,
): Promise<Blob | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = useOrderInvoiceStore()
  const url = useAdminRoutes('admin.order.invoices.preview', { order_id: orderId })

  store.setPreviewLoading(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.post<Blob>(url, payload, { responseType: 'blob' })

    return data
  } catch (err: unknown) {
    toast.error(await getBlobErrorMessage(err))
    return null
  } finally {
    store.setPreviewLoading(false)
  }
}
